import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b88978c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-light container-fluid container-lg dropdown-nav-slider shadow-1-strong" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row justify-content-center collapse",
  id: "learn-more"
}, [
  /*#__PURE__*/_createElementVNode("h4", { class: "col-12 col-lg-8 text-center" }, [
    /*#__PURE__*/_createTextVNode(" Learn "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://ology.substack.com/p/the-time-has-come",
      target: "_blank"
    }, "more"),
    /*#__PURE__*/_createTextVNode(" and "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://ology.substack.com/about",
      target: "_blank"
    }, "subscribe"),
    /*#__PURE__*/_createTextVNode(" for updates. ")
  ])
], -1))
const _hoisted_3 = {
  class: "row justify-content-center",
  id: "search-form"
}
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary btn-block mt-2" }, " Search ", -1))
const _hoisted_7 = { class: "container-fluid container-lg bg-light mt-4" }
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = { class: "col-12 d-flex align-items-center justify-content-center" }

import { ref, onMounted, watch, Ref } from "vue";
    import ArticleThread from "@/components/ArticleThread.vue";
    import { MDBSpinner, MDBBtn } from "mdb-vue-ui-kit";
    import { useRoute } from 'vue-router';
    import * as utility from '@/functions/utility';
    import * as feed from '@/functions/feed';
    import Observer from "@/components/Observer.vue";
    import axios from "axios";
    import router from '@/router';
    import { Thread } from '@/types/Thread';
    import { Feed } from "@/types/Feed";

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const spinnerVisible = ref(false);
    const gettingArticles = ref(false);
    const noMoreResults = ref(false);
    const threads: Ref<Thread[]> = ref([]);
    const feedUrl = ref('');
    const searchParam = ref('');
    const currentPage = ref(1);
    const route = useRoute();

    /**
    * Get Search Data based on Term and Specified Page
    *
    * @param nextPage Boolean to allow more pages to be fetched
    */
    async function getData (nextPage: boolean) {
        if (gettingArticles.value == true) {
            return;
        }

        if (noMoreResults.value === true) {
            return;
        }

        if (nextPage === true) {
            ++currentPage.value;
        }

        spinnerVisible.value = true;
        gettingArticles.value = true;

        let response;

        const currentFeed = ref<Feed>({
            feedUrl: feedUrl.value,
            latestEtag: '',
            articles: Array<Thread>(),
            duplicateArticles: Array<string>(),
            hashes: Array<string>(),
            allArticles: Array<Thread>(),
        });

        let url = process.env.VUE_APP_API_ENDPOINT + '/api/search';

        try {
            response = await axios.post(url, {
                term: searchParam.value,
                page: currentPage.value,
            });
        } catch (e) {
            gettingArticles.value = false;
            spinnerVisible.value = false;
            console.error(e);
        }

        const ingestedArticles = Array<Thread>();
        let results = response?.data?.results;

        if (results.length === 0 || typeof(results) === 'undefined') {
            noMoreResults.value = true;
            spinnerVisible.value = false;
            gettingArticles.value = false;
            return;
        }

        for (let i = 0; i < results.length; i++) {
            const parsedArticle = results[i];

            let convertedArticle = parsedArticle.metainfo;
            convertedArticle.feedCopy = parsedArticle;

            ingestedArticles.push(convertedArticle);
        }

        // filter out articles that have already been displayed
        let newArticles = Array<Thread>();
        for (let j = 0; j < ingestedArticles.length; j++) {
            const article = ingestedArticles[j];

            const valid = await utility.validateArticle(article);

            if (!valid) {
                continue;
            }

            if (article.info.publicSquare.package.canonicalUrl && /twitter.com\/.+\/status/.test(article.info.publicSquare.package.canonicalUrl)) {
                article.contentType = 'Tweet';
            }

            if (currentFeed.value.hashes.includes(article.infoHash) == false) {
                newArticles.push(article);
                // include in allArticles
                currentFeed.value.allArticles.push(article);
            }
        }

        for (let i = 0; i < newArticles.length; i++) {
            let article = newArticles[i];

            currentFeed.value.hashes.push(article.infoHash);
            article = await feed.addReplyThread(currentFeed as unknown as Feed, article);

            // skip if duplicate
            if (currentFeed.value.duplicateArticles.includes(article.infoHash)) {
                continue;
            }

            // add to articles and thread if not a duplicate
            currentFeed.value.articles.push(article);

            if (feedUrl.value !== currentFeed.value.feedUrl) {
                continue;
            }

            // if feed hasn't changed, add new article to thread list
            // @ts-ignore
            threads.value.push(feed.convertArticleToThread(article));

            if (i % 10 === 0) {
                // force it to render every 10 elements
                await utility.skipFrame();

                // hide the spinner after the first 20
                if (i === 20 && spinnerVisible.value === true) {
                    spinnerVisible.value = false;
                }
            }
        }

        spinnerVisible.value = false;
        gettingArticles.value = false;
    }

    function search() {
        if (searchParam.value.length > 0) {
            router.push({ name: 'Search', params: { param: searchParam.value } });
        }
    }

    async function intersected () {
        await getData(true);
    }

    onMounted(async () => {
        currentPage.value = 1;

        let search = route.params.param ? route.params.param : null;

        searchParam.value = search as string;

        await getData(false);
    })

    watch(
        () => route.params.param,
        async newSearch => {
            searchParam.value = newSearch as string;
            currentPage.value = 1;
            noMoreResults.value = false;
            threads.value = [];

            if (typeof(searchParam.value) !== 'undefined' && searchParam.value !== null) {
                await getData(false);
            }
        }
    )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(MDBBtn), {
      color: "primary",
      floating: "",
      size: "lg",
      class: _normalizeClass(spinnerVisible.value ? 'loader-div loading' : 'loader-div')
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MDBSpinner))
      ]),
      _: 1
    }, 8, ["class"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "my-2 col-12 col-lg-8",
          onSubmit: _withModifiers(search, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              required: "",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParam).value = $event)),
              placeholder: "Search For..."
            }, null, 512), [
              [_vModelText, searchParam.value]
            ])
          ]),
          _hoisted_6
        ], 40, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(threads.value, (thread) => {
        return (_openBlock(), _createBlock(ArticleThread, {
          key: 'thread-' + thread[0].infoHash,
          thread: thread,
          feedUrl: feedUrl.value
        }, null, 8, ["thread", "feedUrl"]))
      }), 128)),
      _createVNode(Observer, {
        options: { rootMargin: '1000px' },
        onIntersect: intersected
      }),
      (threads.value.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", null, _toDisplayString(gettingArticles.value ? 'Finding articles...' : 'No articles available'), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})